import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import CurrencyFormat from 'react-currency-format';
import { useTranslation } from "react-i18next";

//import lib
import isEmpty from "../../lib/isEmpty";
import { toFixedDown, truncateDecimals } from "../../lib/roundOf";
import ExchangeModal from "./ExchangeModal";
import { toastAlert } from "../../lib/toastAlert";
import { currencyChange } from "../../lib/pairHelper";

const initialFormValue = {
  isModalOpen: false,
  record: {},
};

const WalletDetails = () => {

  //redux
  const currency = useSelector((state) => state.currency);
  const walletData = useSelector((state) => state.wallet);
  const siteDoc = useSelector((state) => state.siteSetting);

  const priceConversion = useSelector((state) => state.priceConversion);
  const { isStake, isTrade, defaultcurrency, adminComment, isExchange } = useSelector((state) => state.account);

  const history = useNavigate()
  const { t, i18n } = useTranslation()

  //state
  const [showBalance, setshowBalance] = useState(false);
  const [totalUSD, setTotalUSD] = useState(0);
  const [Wallet, setWallet] = useState([]);
  const [check, setCheck] = useState(false);
  const [filter, setFilter] = useState(true)
  const [exchangeData, setExhangeData] = useState(initialFormValue);
  const [loader, setLoading] = useState(true);
  const [PriceChange, setPriceChange] = useState()

  //function
  const handleSearch = (e) => {
    let { name, value } = e.target;
    function getSearch(item) {
      return (
        item.coin.toLowerCase() == value?.toLowerCase() ||
        item.stakeBal == value ||
        item.spotInOrder == value ||
        item.USDValue == value
      );
    }
    let filterDoc = Wallet.filter(getSearch);
    if (!isEmpty(filterDoc)) {
      setWallet(filterDoc);
      setFilter(true)
    } else {
      setFilter(false)
    }

    if (isEmpty(value)) {
      handleAsset();
      setFilter(true)
    }
  };

  const handleAsset = () => {
    try {
      let totalAmount = 0;
      let tempArr = [...walletData];
      currency?.length >= 0 &&
        currency.map((item, index) => {
          let PriceCnv = priceConversion.find(
            (el) =>
              el.baseSymbol == item.currencySymbol && el.convertSymbol == "USD" ||
              el.baseSymbol == "USD" && el.convertSymbol == item.currencySymbol
          );
          let pairIndex =
            tempArr &&
            tempArr.findIndex((el) => {
              return el._id == item._id;
            });
          if (pairIndex >= 0 && !isEmpty(pairIndex)) {
            let Balance = tempArr[pairIndex].stakeBal - tempArr[pairIndex].lockedBal
            tempArr[pairIndex] = {
              ...tempArr[pairIndex],
              ...{
                image: item.image,
                decimals: item.decimals,
                status: item.status,
                USDValue: !isEmpty(PriceCnv?.convertPrice) ? parseFloat(Balance * PriceCnv.convertPrice) : Balance,
              },
            };
            totalAmount += tempArr[pairIndex].USDValue;
          }
        });

      if (defaultcurrency == "USD") {
        setTotalUSD(totalAmount);
      } else {
        let totalbalance = !isEmpty(PriceChange) ? parseFloat(totalAmount * PriceChange) : 0
        setTotalUSD(totalbalance);
      }

      setWallet(tempArr);
      setLoading(false)
    } catch (err) {
      setLoading(false)
      console.log("err:------ ", err);
    }
  };


  const handleCloseModal = () => {
    setExhangeData({ isModalOpen: false, record: {} });
  };


  const handleStake = () => {
    if (isStake) {
      history("/staking")
    } else {
      toastAlert("error", t("STAKE_ACCESS"), "login");
    }

  }

  const handleExchange = (item) => {
    if (isExchange) {
      setExhangeData({
        isModalOpen: true,
        record: item?.item,
      });
    } else {
      toastAlert("error", t("EXCHANGE_ACCESS"), "login");
    }

  }

  useEffect(() => {
    if (!isEmpty(walletData) && !isEmpty(currency) && !isEmpty(priceConversion)) {
      handleAsset();
    }
    if (defaultcurrency != "USD") {
      let convetCurrency = priceConversion && priceConversion.length > 0 && priceConversion.find((el) => el.baseSymbol == "USD" && el.convertSymbol == defaultcurrency)
      if (convetCurrency?.convertPrice) {
        let amount = !isEmpty(convetCurrency?.convertPrice) ? parseFloat(convetCurrency?.convertPrice) : 1
        setPriceChange(amount)
      } else {
        setPriceChange(0)
      }
    }

  }, [walletData, currency, priceConversion, defaultcurrency]);


  //  console.log(defaultcurrency,'isExchange')
  return (
    <>
      <ExchangeModal
        isShow={exchangeData.isModalOpen}
        record={exchangeData.record}
        onHide={handleCloseModal} />

      {!isEmpty(adminComment) && <div className="primary_btn" style={{ "width": "50%" }} ><p className="text-small" >{adminComment}</p></div>}

      <div className="staking_top_flex flex flex-col lg:flex-row gap-4 items-start lg:items-center justify-between mb-4">
        <div className="w-full lg:w-[346px] p-4 relative bg-[conic-gradient(from_310deg_at_52.02%_59.26%,_#395645_0deg,_#203328_360deg)] rounded inline-flex flex-col justify-center items-start gap-2 overflow-hidden">
          <img src="/images/inner/bg2.png" alt="" className="absolute bottom-0 right-0 pointer-events-none z-0" />
          <div className="w-full inline-flex justify-between items-center z-10">
            <div className="justify-center text-[#f4f3f3] text-sm font-normal font-['Roobert']">{t("TOTAL_BALANCE")}:</div>
            <i
              onClick={() => setshowBalance(showBalance ? false : true)}
              className={`${showBalance ? "bi bi-eye" : "bi bi-eye-slash"} text-[#f4f3f3] cursor-pointer`}
            ></i>
          </div>
          <div className="justify-center text-white text-xl font-normal font-['Roobert'] z-10">
            {currencyChange(defaultcurrency)} {showBalance ? <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(totalUSD ? totalUSD : 0, 2)} /> : "********"}
          </div>
        </div>

        <div className="wallet_page_right_flex flex flex-col sm:flex-row items-start sm:items-center gap-4 w-full lg:w-auto mt-4 lg:mt-0">
          <div className="form-check mb-0">
            <input
              className="form-check-input cursor-pointer"
              type="checkbox"
              id="inlineCheckbox1"
              checked={check}
              onChange={() => setCheck(!check)}
            />
            <label htmlFor="inlineCheckbox1" className="form-check-label text-[#6b7280] cursor-pointer select-none">
              {t("HIDE_ZERO_BALANCES")}
            </label>
          </div>
          <div className="w-full sm:w-[311px] self-stretch p-2 rounded-sm outline outline-1 outline-offset-[-1px] outline-[#6b7280]/25 inline-flex flex-col justify-start items-center gap-6">
            <div className="self-stretch inline-flex justify-start items-center gap-2">
              <div className=" relative overflow-hidden flex-shrink-0">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.332 11.332L13.9987 13.9987" stroke="#6B7280" stroke-width="1.5" stroke-linecap="square" />
                  <path d="M12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333Z" stroke="#6B7280" stroke-width="1.5" stroke-linecap="square" />
                </svg>
              </div>
              <input
                type="text"
                placeholder={t("SEARCH")}
                onChange={handleSearch}
                className="w-full bg-transparent border-none outline-none text-[#6b7280] text-[15px] font-normal font-['Roobert'] placeholder:text-[#6b7280]"
              />
            </div>
          </div>
          <a href={`${siteDoc?.whatsappLink}`} target="_blank" rel="noreferrer" className="">
            <img
              src={require("../../assets/images/whatapp.png")}
              alt="WhatsApp"
              className="img-fluid"
              width={40}
            />
          </a>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table wallet_table">
          <thead>
            <tr>
              <th>{t("ASSET")}</th>
              <th>{t("BALANCE")}</th>
              {/* <th>Locked</th> */}
              <th>{t("ACTION")}</th>
            </tr>
          </thead>
          <tbody>
            {Wallet?.length > 0 &&
              Wallet.map((item, index) => {
                let Balance = item?.stakeBal - item?.lockedBal;
                if (filter && item?.status == "active") {
                  if (check) {
                    if (item?.stakeBal > 0) {
                      return (
                        <tr>
                          <td>
                            <div className="table_asset">
                              <img
                                src={item.image}
                                alt="Crypto"
                                className="img-fluid"
                                loading="lazy"
                              />
                              <span>{item.coin}</span>
                            </div>
                          </td>
                          <td>
                            <p className="mb-0">
                              <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(Balance, item?.decimals)} />{" "}
                              &nbsp; {item?.coin}
                            </p>
                            <span>≈ {currencyChange(defaultcurrency)} {item.USDValue ? <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(defaultcurrency == "USD" ? item?.USDValue : PriceChange * item?.USDValue, item?.decimals)} /> : 0}
                            </span>
                          </td>
                          {/* <td>0 BTC</td> */}
                          <td>
                            <div className="button_grp mt-0 flex gap-2 ">
                              <Link to={`/deposit/${item?._id}`} className="h-9 px-4 relative rounded-sm outline outline-1 outline-offset-[-1px] outline-[#395645] inline-flex flex-col justify-center items-center overflow-hidden hover:bg-[#395645] active:scale-95 transition-all duration-200 group no-underline">
                                <div className="text-center justify-center text-[#395645] group-hover:text-white text-base font-medium font-['Roobert'] transition-colors">{t("DEPOSIT")}</div>
                              </Link>
                              <Link
                                to={`/withdraw/${item?._id}`}
                                className="h-9 px-4 relative rounded-sm outline outline-1 outline-offset-[-1px] outline-[#395645] inline-flex flex-col justify-center items-center overflow-hidden hover:bg-[#395645] active:scale-95 transition-all duration-200 group no-underline"
                              >
                                <div className="text-center justify-center text-[#395645] group-hover:text-white text-base font-medium font-['Roobert'] transition-colors">{t("WITHDRAW")}</div>
                              </Link>
                              <button onClick={() => {
                                handleExchange({
                                  item
                                });
                              }} className="h-9 px-4 relative rounded-sm outline outline-1 outline-offset-[-1px] outline-[#395645] inline-flex flex-col justify-center items-center overflow-hidden hover:bg-[#395645] active:scale-95 transition-all duration-200 group border-0 bg-transparent">
                                <div className="text-center justify-center text-[#395645] group-hover:text-white text-base font-medium font-['Roobert'] transition-colors">{t("EXCHANGE")}</div>
                              </button>

                              <button onClick={handleStake} className="h-9 px-4 relative rounded-sm outline outline-1 outline-offset-[-1px] outline-[#395645] inline-flex flex-col justify-center items-center overflow-hidden hover:bg-[#395645] active:scale-95 transition-all duration-200 group border-0 bg-transparent">
                                <div className="text-center justify-center text-[#395645] group-hover:text-white text-base font-medium font-['Roobert'] transition-colors">{t('STAKE')}</div>
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  } else {
                    if (filter) {
                      return (
                        <tr>
                          <td>
                            <div className="table_asset">
                              <img
                                src={item?.image}
                                alt="Crypto"
                                className="img-fluid"
                              />
                              <span>{item?.coin}</span>
                            </div>
                          </td>
                          <td>
                            <p className="mb-0">
                              <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(Balance, item?.decimals)} />
                              &nbsp;{item?.coin}
                            </p>
                            <span>≈ {currencyChange(defaultcurrency)} {item.USDValue ? <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(defaultcurrency == "USD" ? item?.USDValue : PriceChange * item?.USDValue, item?.decimals)} /> : 0} </span>
                          </td>
                          <td>
                            <div className="button_grp mt-0 flex gap-2 ">
                              <Link to={`/deposit/${item?._id}`} className="h-9 px-4 relative rounded-sm outline outline-1 outline-offset-[-1px] outline-[#395645] inline-flex flex-col justify-center items-center overflow-hidden hover:bg-[#395645] active:scale-95 transition-all duration-200 group no-underline">
                                <div className="text-center justify-center text-[#395645] group-hover:text-white text-base font-medium font-['Roobert'] transition-colors">{t("DEPOSIT")}</div>
                              </Link>
                              <Link
                                to={`/withdraw/${item?._id}`}
                                className="h-9 px-4 relative rounded-sm outline outline-1 outline-offset-[-1px] outline-[#395645] inline-flex flex-col justify-center items-center overflow-hidden hover:bg-[#395645] active:scale-95 transition-all duration-200 group no-underline"
                              >
                                <div className="text-center justify-center text-[#395645] group-hover:text-white text-base font-medium font-['Roobert'] transition-colors">{t("WITHDRAW")}</div>
                              </Link>
                              <button onClick={() => {
                                handleExchange({
                                  item
                                });
                              }} className="h-9 px-4 relative rounded-sm outline outline-1 outline-offset-[-1px] outline-[#395645] inline-flex flex-col justify-center items-center overflow-hidden hover:bg-[#395645] active:scale-95 transition-all duration-200 group border-0 bg-transparent">
                                <div className="text-center justify-center text-[#395645] group-hover:text-white text-base font-medium font-['Roobert'] transition-colors">{t("EXCHANGE")}</div>
                              </button>

                              <button onClick={handleStake} className="h-9 px-4 relative rounded-sm outline outline-1 outline-offset-[-1px] outline-[#395645] inline-flex flex-col justify-center items-center overflow-hidden hover:bg-[#395645] active:scale-95 transition-all duration-200 group border-0 bg-transparent">
                                <div className="text-center justify-center text-[#395645] group-hover:text-white text-base font-medium font-['Roobert'] transition-colors">{t('STAKE')}</div>
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  }
                }
              })}
            {
              !loader && Wallet && Wallet.length <= 0 || !filter && <span style={{ position: 'center' }} >{t("THERE_NO_RECORD")}</span>
            }
            {loader && (
              <span style={{ textAlign: "center", display: "inline-block" }}>
                {t("LOADING")}...
              </span>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default WalletDetails;
